import { css } from '@emotion/css';
import { Colors } from './colors';
import { Motion, Radius, Shadow } from './tokens';

/**
 * Shared look for the 4-digit verification code boxes (sign-up and
 * change-email flows).
 */
export const codeInputStyle = (errorState: boolean): string => css`
  display: flex;
  width: 100% !important;

  div {
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 0.75rem;
  }

  input {
    border: 2px solid ${Colors.BORDER_STRONG} !important;
    border-radius: ${Radius.md} !important;
    background: ${Colors.WHITE};
    text-align: center;
    font: normal normal bold 2rem Doctrine !important;
    font-variant-numeric: tabular-nums;
    color: ${Colors.BLACK} !important;
    outline: none;
    transition:
      border-color ${Motion.fast},
      box-shadow ${Motion.fast};

    ${errorState === true &&
    `
      border-color: ${Colors.ERROR_DARK} !important;
    `}
  }

  input:focus {
    border-color: ${Colors.CAPRI_BLUE} !important;
    box-shadow: ${Shadow.focus};
  }
`;
